import Api from 'core/services/api'
import {
  getAllMediaRequest,
  createMediaRequest,
  createMediaURLRequest,
  removeMediaRequest,
} from 'core/services/models'

const path = '/v1/media'
const pathCore = '/v1/core/products/media'

export const getAllMedia = ({ fingerprint }: getAllMediaRequest) => {
  return Api.request({
    url: path,
    params: { fingerprint },
    method: 'GET',
  })
}

export const createMedia = ({ form, progress }: createMediaRequest) => {
  return Api.request({
    url: path,
    method: 'POST',
    data: form,
    onUploadProgress: progress,
  })
}

export const createCustomMedia = ({ form, progress }: createMediaRequest) => {
  return Api.request({
    url: pathCore,
    method: 'POST',
    data: form,
    onUploadProgress: progress,
    headers: {
      'x-channel': 'netshoes',
    },
  })
}

export const createMediaURL = ({ form }: createMediaURLRequest) => {
  return Api.request({
    url: path,
    method: 'POST',
    data: form,
  })
}

export const createCustomMediaURL = ({ form }: createMediaURLRequest) => {
  return Api.request({
    url: pathCore,
    method: 'POST',
    data: form,
    headers: {
      'x-channel': 'netshoes',
    },
  })
}

export const removeMedia = ({ id }: removeMediaRequest) => {
  return Api.request({
    url: `${path}/${id}`,
    method: 'DELETE',
  })
}
